// ThemeToggle — botão que alterna light ↔ dark.
// A11y: aria-label dinâmico, title pra usuários sighted, foco visível
// herdado dos tokens. Sem confirmação — clique único é o contrato.
import { useTheme, type Theme } from '@/lib/theme';
import { MoonIcon, SunIcon } from '@/components/icons';
import styles from './ThemeToggle.module.css';

const ORDER: Theme[] = ['light', 'dark'];

const LABELS: Record<Theme, { aria: string; title: string; next: Theme }> = {
  light: {
    aria: 'Tema atual: claro. Clique pra trocar pra escuro.',
    title: 'Tema: claro',
    next: 'dark',
  },
  dark: {
    aria: 'Tema atual: escuro. Clique pra trocar pra claro.',
    title: 'Tema: escuro',
    next: 'light',
  },
};

function iconFor(theme: Theme) {
  return theme === 'light' ? <SunIcon size={16} /> : <MoonIcon size={16} />;
}

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const meta = LABELS[theme];

  function cycle() {
    const idx = ORDER.indexOf(theme);
    const next = ORDER[(idx + 1) % ORDER.length];
    setTheme(next);
  }

  return (
    <button
      type="button"
      className={styles.button}
      onClick={cycle}
      aria-label={meta.aria}
      title={meta.title}
      data-theme={theme}
    >
      <span className={styles.icon} aria-hidden="true">
        {iconFor(theme)}
      </span>
    </button>
  );
}

export default ThemeToggle;
